// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action  failed',
  success: 'Action was successful',
  validation: {
    required: 'Le champ {attribute} est obligatoire.',
    minLength: 'Le champ {attribute} doit contenir au moins {min} caractères.',
    email: 'Email valide requis'
  }
}
